{
    "config": [
        {
            "orderTpe": "EMER-BLOWING GAS",
            "leakageVisibilty": true,
            "leakageRequired": true,
            "inside": {
                "typeOfBuildingRequired": true,
                "whichRoomRequired": true,
                "isLeakAtApplianceRequired": true,
                "applianceRequired": true,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": true,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-CO",
            "leakageVisibilty": false,
            "leakageRequired": false,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-EXPLOSION",
            "leakageVisibilty": true,
            "leakageRequired": true,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-FIRE",
            "leakageVisibilty": true,
            "leakageRequired": false,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-LO/HI PRESSURE",
            "leakageVisibilty": false,
            "leakageRequired": false,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-LEAK INSIDE",
            "leakageVisibilty": true,
            "leakageRequired": true,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-LEAK OUTSIDE",
            "leakageVisibilty": true,
            "leakageRequired": true,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-LEAK STREET",
            "leakageVisibilty": true,
            "leakageRequired": true,
            "inside": {
                "typeOfBuildingRequired": true,
                "whichRoomRequired": true,
                "isLeakAtApplianceRequired": true,
                "applianceRequired": true,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": true,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-NO GAS",
            "leakageVisibilty": false,
            "leakageRequired": false,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        },
        {
            "orderTpe": "EMER-PIPELINE",
            "leakageVisibilty": true,
            "leakageRequired": true,
            "inside": {
                "typeOfBuildingRequired": false,
                "whichRoomRequired": false,
                "isLeakAtApplianceRequired": false,
                "applianceRequired": false,
                "leakInHousePipingRequired": false
            },
            "outSide": {
                "whereLeakLocatedRequired": false,
                "addLocationCommentsRequired": false
            }
        }
    ]
}